import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import { ChatProvider } from '@/contexts/ChatContext';
import { Toaster } from 'sonner';
import LoginPage from '@/pages/LoginPage';
import SetPasswordPage from '@/pages/SetPasswordPage';
import OrganizerDashboard from '@/pages/OrganizerDashboard';
import ParticipantDashboard from '@/pages/ParticipantDashboard';
import ProfilePage from '@/pages/ProfilePage';
import AdminPanel from '@/pages/AdminPanel';
import AnalyticsPage from '@/pages/AnalyticsPage';
import Layout from '@/components/Layout';
import ChatWidget from '@/components/ChatWidget';
import PwaStatusBanner from '@/components/PwaStatusBanner';
import '@/App.css';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-[#0046AD] border-t-transparent rounded-full animate-spin" />
          <span className="text-sm text-slate-500">Загрузка...</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function DashboardRouter() {
  const { user } = useAuth();
  if (user?.role === 'organizer') return <OrganizerDashboard />;
  return <ParticipantDashboard />;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  return (
    <Routes>
      <Route path="/" element={!loading && user ? <Navigate to="/dashboard" replace /> : <LoginPage />} />
      <Route path="/set-password" element={<SetPasswordPage />} />
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <Layout><DashboardRouter /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/profile" element={
        <ProtectedRoute>
          <Layout><ProfilePage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/admin" element={
        <ProtectedRoute>
          <Layout><AdminPanel /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/analytics" element={
        <ProtectedRoute>
          <Layout><AnalyticsPage /></Layout>
        </ProtectedRoute>
      } />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ChatProvider>
          <Toaster position="bottom-right" richColors />
          <AppRoutes />
          <ChatWidget />
          <PwaStatusBanner />
        </ChatProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
